import _ from 'lodash'

/**
 * ファイルを読み込む
 * @param file CSVファイル
 */
export function readCsv(file: File): Promise<FileReader> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader)
    reader.onerror = (error) => reject(error)
    reader.readAsText(file)
  })
}

/**
 * CSVの登録件数を数える
 * @param reader チェックするCSVのFileReader
 * @return {number} CSVの登録件数
 */
export function countRecords(reader: FileReader): number {
  return _.chain(reader.result)
    .split('\n')
    .drop()
    .compact()
    .value()
    .length
}
